<template>
 <div style="height:100%"><FileList :assocID="assocID" :module="module"></FileList></div>
</template>
<script>
import FileList from "./FileList";
export default {
  name: "ProjectData",
  controller: "UI",
  action: "ProjectData",
  components:{
    FileList
  },
  data() {
      return{
        assocID:"xiangmuzhil",
        module:"项目资料"
      }
  },
  created:function() {
  },
  mounted: function() {   
  },
  methods: {
  }
}
</script>
